<template>
  <div class="breadcrumbs" v-if="!isHome">
    <div class="container">
      <ul>
        <li>
          <router-link :to="{ path: getHome(data.settings.translatable, locality) }">{{ getSnippets('Home') }}</router-link>
        </li>
        <li v-for="(item, index) in data.breadcrumbs" :key="index" class="additional">
          <router-link :to="{ path: item.slug }">
            {{ item.translations[data.settings.locality].title }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {Default} from '@mixins/Default';

/* Logic */
export default {
  name: 'Breadcrumbs',
  mixins: [Default],
  props: [
    'data',
  ],
  computed: {
    isHome() {
      return this.data.page.category.title === 'Home';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@css/core/_variables.scss";
@import "@css/mixins/_breakpoints.scss";
@import "@css/mixins/_functions.scss";

.breadcrumbs {
  position: relative;
  padding: 8px 0;
  background-color: $grey-light-3;

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    scrollbar-color: $white $white;
    scrollbar-width: 0;
    scrollbar-height: 0;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color-1;
      outline: 0 solid $color-1;
    }

    // Mobile
    @include media-breakpoint-down(md) {
      overflow-x: scroll;
      white-space: nowrap;
    }

    li {
      display: inline-flex;
      margin-right: 16px;

      &:last-child {
        a {
          &:after {
            content: unset;
          }
        }
      }

      a {
        position: relative;
        display: block;
        font-size: 14px;
        font-weight: 400;

        &:after {
          content: "/";
          color: #757575;
          position: absolute;
          right: -12px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/App/Partials/Breadcrumbs.vue